import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-muted-foreground">Nie znaleziono strony.</p>
      <Button asChild>
        <Link to="/">Wróć do strony głównej</Link>
      </Button>
    </div>
  );
}
